<template>
    <div>
        <div class='card'>

            <div class="card-header ">
                <div class='name f3 fw8 w-100 ml-2'> Dados do Comprador  </div>
            </div>


            <div class='card-body'>

                    <div v-if="this.error" class='alert alert-danger'>
                        {{ this.error }}
                    </div>

                    <!-- <user-register-form v-model="buyerInfo"/> -->
                    <div v-if="userWithDataExist && user == false" class='alert alert-warning'> Usuário com o CPF já cadastrado. Faça o seu login abaixo!</div>
                    
                    <!-- <pre> {{ user }} </pre> -->
                    <div v-if="user && !edit">
                            <h6>Nome: <b>{{ user.name }}</b></h6>
                            <h6>CPF: <b>{{ user.cpf }}</b></h6>
                            <h6>Email: <b>{{ user.email }}</b></h6>
                            <h6>Endereço: <b>{{ user.address.rua }},{{ user.address.bairro }},{{ user.address.numero }} - {{ user.address.cidade }},{{ user.address.estado }}</b></h6>
                            <a class='btn btn-default' @click="editUser">
                               Editar
                            </a>
                            <hr />
                            <a @click="logout">
                               Registrar novo comprador
                            </a>
                    </div>

                    <vue-form  v-if="!user || (edit && user != false)" name="clientinfoform" v-model="clientInfo" class='mt-2'>
                        <div class="row">
                            <vue-field class='col-12' @input="checkIfUserExistCPF" type="string" ref="cpf" name="cpf" label="CPF" required :validations="['cpf']"></vue-field>
                            <div class="col-12">

                            <div v-show="(!userWithDataExist && hasCheckCpf) || (edit && user != false)" class='row'>
                                <vue-field  class='col-12 col-lg-6' type="string" name="name" label="Nome Completo" required></vue-field>
                                <vue-field  class='col-12 col-lg-6' type="string" name="email" label="Email" required :validations="['email']"></vue-field>
                                <vue-field  class='col-12 col-lg-6' type="age" name="birthday" label="Data de Nascimento" required ></vue-field>
                                <vue-field  class='col-12 col-lg-6' type="string" name="telephone" label="Telefone" required ></vue-field>
                                <vue-field  class='col-12 col-lg-6' type="address" name="address" label="Endereço" />
                                <vue-field  class='col-12 col-lg-6' type="password" name="passwordNew" label="Senha (caso queira redefinir)" ></vue-field>

                            </div>
                            </div>
                            <div v-show="hasCheckCpf && !edit && !user"  class='w-100'>
                                <vue-field  class='col-12 col-lg-6' type="password" name="password" label="Senha" ></vue-field>
                           
                            </div>

                            <div v-show="hasCheckCpf && userWithDataExist && user == false"  class='col-12'>
                                <div class="row">
                                    <div class="col-6">
                                         <a class='btn btn-primary' style="color:white" @click="login">Logar</a>
                                    </div>
                                     <div class="col-6">
                                         <div style='text-align:right; font-size:0.9em'><a @click.prevent='submitEsqueceuSenha' submitEsqueceuSenha href="">Esqueceu sua senha?</a>
                                    </div>
                                </div>
                            


                            </div>

                               <div  v-if="msgrecuperarsenha" class="row" style="margin-top:1em">
                                    <div class="col-12">
                                        <div class="alert alert-success">
                                            {{this.msgrecuperarsenha}} <br/>
                                            Verifique seu email, atualize sua senha e faça o login com sua nova senha.
                                        </div>
                                    </div>
                                </div>
                               
                            </div>

                            <div class="col-12">
                             <a class='btn btn-primary' style="color:white" v-if="(edit && user != false)" @click="editUserInfo">
                               Salvar
                            </a>
                             <a class='btn' v-if="(edit && user != false)" @click="edit=false">
                               Cancelar
                            </a>
                            </div>


                        </div>
                    </vue-form>
                    
                     <div v-if="this.error" class='alert alert-danger'>
                        {{ this.error }}
                    </div>

            </div>


        </div>

    </div>
</template>

<script>

import validadeFormMixins from "@/mixins/validateForms"
import api from "@/api"

export default {
    mixins:[validadeFormMixins],

    data(){
        return{
            clientInfo:{},
            error:false,
            edit:false,
            registerAnother:false,
            erromsg:'',
            msgrecuperarsenha:'',
            userWithDataExist:false,
            hasCheckCpf:false,
            esqueceusenha:false
        }
    },

    watch:{
      
    },

    computed:{
        user:function(){
            return this.$store.getters.user
        }
    },

    methods:{

        editUser:function(){
            this.edit = true;
            let password = this.clientInfo.password
            this.clientInfo = this.user;
            this.clientInfo.password = password
        },

        logout:function(){
            this.$store.dispatch('logout');
            this.clientInfo = {}
        },
        login:async function(){

            var response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 

            if(response.error){
                    this.error = response.message;
                    if(this.error === 'Unauthorized')
                         this.error = "Usuário ou Senha inválidos!"
                    return false;
            }else{
                this.error = false;
                return true;
            }
        },

        editUserInfo: async function(){
                //try to relogin
                // response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
                //  if(response.error){
                //     this.error = response.data.error.message;
                //     return false;
                //  }
                
                let userData =  {...this.clientInfo}
                if(userData.passwordNew){
                    userData.password = userData.passwordNew
                }else{
                    delete userData.password
                }
                delete userData.passwordNew
                //if ok, save data
                let response = await this.$store.dispatch('updateUser', userData )
                if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }
                 this.edit = false
                 return true;

        },


          submitEsqueceuSenha:async function(){

            this.error = false;
            this.msg = false;
            let response = await this.$store.dispatch('recoverpassword', { cpf:this.clientInfo.cpf } ) 
            if(response.error){
                    this.error = "Dados inválidos" //response.data.error.message;
                    return false;
            }else{
                this.error = false;
                this.msgrecuperarsenha ="Um email foi enviado para "+response.email
                return true;
            }

        },

        validarCPF:function(cpf) {	
                cpf = cpf.replace(/[^\d]+/g,'');	
                if(cpf == '') return false;	
                // Elimina CPFs invalidos conhecidos	
                if (cpf.length != 11 || 
                    cpf == "00000000000" || 
                    cpf == "11111111111" || 
                    cpf == "22222222222" || 
                    cpf == "33333333333" || 
                    cpf == "44444444444" || 
                    cpf == "55555555555" || 
                    cpf == "66666666666" || 
                    cpf == "77777777777" || 
                    cpf == "88888888888" || 
                    cpf == "99999999999")
                        return false;		
                // Valida 1o digito	
                let add = 0;
                let ref;	
                for (let i=0; i < 9; i ++)		
                    add += parseInt(cpf.charAt(i)) * (10 - i);	
                    rev = 11 - (add % 11);	
                    if (rev == 10 || rev == 11)		
                        rev = 0;	
                    if (rev != parseInt(cpf.charAt(9)))		
                        return false;		
                // Valida 2o digito	
                add = 0;	
                for (let i = 0; i < 10; i ++)		
                    add += parseInt(cpf.charAt(i)) * (11 - i);	
                rev = 11 - (add % 11);	
                if (rev == 10 || rev == 11)	
                    rev = 0;	
                if (rev != parseInt(cpf.charAt(10)))
                    return false;		
                return true;   
        },

        checkIfUserExistCPF:async function(val){
            //check if we have a user with this cpf or email, 
            // var cpf = this.buyerInfo.cpf;
            // console.log(cpf)



            let cpf = val.replace(/\D/g, '');

            if( cpf.length < 11  ){
                return false
            }

            let validate = await this.$refs.cpf.validate();
            
            if( validate == false){
                return false;
            }

            if( _.isEmpty(cpf)) {
                this.userWithDataExist = false;
                return true; 
            }
            let exist = await api.postJSONAsync('userExist', { cpf } )
            this.hasCheckCpf = true;
            //if we have
            //say to user login, or continue without password
            if(exist){ 
                this.userWithDataExist = true
            }else{
                this.userWithDataExist = false
            }

        },


        formsOk: async function(){

            let response;

            if(this.user && this.edit == false){
                //update user
                return true
            }
            
            if(this.user && this.edit){
               this.editUserInfo()
            }
            
            if(this.userWithDataExist){
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
            
            }else{
                var formValid = await this.validateForms();
                if(formValid){
                    if(this.userWithDataExist){
                        
                    }else{
                        response = await this.$store.dispatch('register', this.clientInfo )
                    }
                }else{
                    return false
                }
            }

            if(response.error){
                    this.error = response.data.error.message;
                    return false;
            }else{
                return true;
            }

        }
    }

}
</script>

<style>

</style>
